export interface Activity {
  organization: string;
  position: string;
  period: string;
  description: string;
  type: 'club' | 'society' | 'startup';
}

export const activities: Activity[] = [
  {
    organization: '가톨릭대학교 컴퓨터정보공학부 전공학회 F.A.N',
    position: '인사담당 운영진',
    period: '2021.03 - 2022.02',
    description: '전공학회 F.A.N에서 인사담당 운영진으로 활동하며 학회원 관리 및 행사 기획을 담당했습니다.',
    type: 'society'
  },
  {
    organization: '가톨릭대학교 컴퓨터정보공학부 전공학회 F.A.N',
    position: '부회장',
    period: '2022.03 - 2023.02',
    description: '전공학회 F.A.N 부회장으로 활동하며 학회 운영 및 리더십 경험을 쌓았습니다.',
    type: 'society'
  },
  {
    organization: '전국 연합 앱런칭 동아리 UMC 3rd',
    position: '가톨릭대학교 회장',
    period: '2022.07 - 2023.02',
    description: 'UMC 3rd 가톨릭대학교 회장으로 활동하며 동아리 운영 및 프로젝트 리드를 담당했습니다.',
    type: 'club'
  },
  {
    organization: '수익형 앱런칭 동아리 CMC 12th',
    position: 'Server Developer',
    period: '2022.12 - 2023.03',
    description: 'CMC 12th에서 Server Developer로 활동하며 백엔드 개발을 담당했습니다.',
    type: 'club'
  },
  {
    organization: '전국 연합 앱런칭 동아리 UMC 4th',
    position: '가톨릭대학교 부회장',
    period: '2023.02 - 2023.08',
    description: 'UMC 4th 가톨릭대학교 부회장으로 활동하며 동아리 운영 및 멘토링을 담당했습니다.',
    type: 'club'
  },
  {
    organization: '수익형 앱런칭 동아리 CMC 13th',
    position: 'Server 파트장',
    period: '2023.04 - 2023.09',
    description: 'CMC 13th에서 Server 파트장으로 활동하며 백엔드 팀을 리드하고 프로젝트를 관리했습니다.',
    type: 'club'
  },
  {
    organization: '수익형 앱런칭 동아리 CMC 14th',
    position: 'Tech Head Lead',
    period: '2023.09 - 2024.02',
    description: 'CMC 14th에서 Tech Head Lead로 활동하며 전체 기술 스택을 리드하고 아키텍처 설계를 담당했습니다.',
    type: 'club'
  }
];
